import { ReactNode } from 'react';
import styled from 'styled-components';

import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { H4 } from '@r1-frontend/ui-react/components/typography/heading';
import { Paragraph5 } from '@r1-frontend/ui-react/components/typography/paragraph';
import TextWrapper from '@r1-frontend/ui-react/components/typography/TextWrapper';
import WebpImage from '@r1-frontend/ui-react/components/WebpImage';
import { FullWidthListContainer, IndentContainer, NonStaticContainer } from '@r1-frontend/ui-react/experimental/containers';
import { BorderRadius } from '@r1-frontend/ui-react/tokens/borderRadius';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';

interface IBannerProps {
    title: string,
    image: {
        url: string,
        urlWebp?: string,
    },

    description?: string | JSX.Element | ReactNode,
    className?: string,
    onBannerClick?: () => void,
}

const TestDriveBanner = ({ title, image, description, onBannerClick, className }: IBannerProps): JSX.Element => {
    return (
        <FullWidthListContainer
            $size={8}
            $direction={'row'}
            $wrap={'nowrap'}
            $justifyContent={'space-between'}
            $alignItems={'center'}
            onClick={onBannerClick}
            className={className}
        >
            <IndentContainer $desktop={[24]} $mobile={[16]}>
                <TextWrapper $lastIndent={false}>
                    <H4 $withIndent={false} $smaller>{title}</H4>
                    {description && (
                        typeof description === 'string'
                        ? <Paragraph5 dangerouslySetInnerHTML={{ __html: description }}/>
                        : description
                    )}
                </TextWrapper>
            </IndentContainer>
            <NonStaticContainer $united={{ $position: 'relative', $left: 0, $bottom: 0, $right: 0 }}>
                <WebpImage urlWebp={image.urlWebp}>
                    <img src={image.url} alt='Изображение баннера'/>
                </WebpImage>
            </NonStaticContainer>
        </FullWidthListContainer>
    );
};

export default styled(TestDriveBanner)`
    position: relative;
    height: 112px;
    background-color: ${COLORS.BgSurface};
    border-radius: ${BorderRadius.OuterBlockRadius};
    cursor: pointer;

    & > ${NonStaticContainer} {
        align-self: flex-end;

        img,
        picture {
            width: 128px;
            height: 128px;
            object-position: center;
            object-fit: contain;
        }
    }

    @media (max-width: ${wideBreakpoints.mobile}) {
        height: 96px;
        border-radius: ${BorderRadius.InnerBlockRadius};

        & > ${NonStaticContainer} {
            img,
            picture {
                width: 112px;
                height: 112px;
            }
        }
    }
`;
